module.exports = __webpack_public_path__ + "img/touzi-logo.f3dcfe92.png";